import { BoardSectionItemHighlight } from '#components/Board/Section/Items/BoardSectionItemHighlight';
import { ImageModule } from '#components/Image/ImageModule';
import { useEnvironment } from '#cutils/context/EnvironmentContext';
import type { BoardTeaser } from '#domains/resolver/board-section-data';
import { TrackEventDataType } from '#types/tracking';
import { Tracktor } from 'react-tracktor';

type Props = {
	teaser: BoardTeaser;
	sizes: string;
};

export function BoardSectionItemBoardHighlight({ teaser, sizes }: Props) {
	const {
		constants: { appUrl },
	} = useEnvironment();

	const imageComp = <ImageModule image={teaser.media} enableZoomEffect={true} sizes={sizes} />;

	return (
		<Tracktor
			trackingData={{
				data: {
					target: {
						title: teaser.title,
						url: `${appUrl}${teaser.link}`,
					},
					type: TrackEventDataType.BoardClick,
				},
			}}
		>
			{({ trackEvent }) => (
				<BoardSectionItemHighlight image={imageComp} onClick={() => trackEvent({})} path={teaser.link} title={teaser.title} />
			)}
		</Tracktor>
	);
}
